'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createFormValues = require('../createFormValues');

var _createFormValues2 = _interopRequireDefault(_createFormValues);

var _immutable = require('../structure/immutable');

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createFormValues2.default)(_immutable2.default);